import { TextFieldProps } from '@mui/material';
import { I18nStore } from '@tools/i18n/store';
import { injectTSDI } from '@tools/tsdi';
import { FieldState } from 'formstate';
import { observer } from 'mobx-react';
import {
    MuiTelInput,
    MuiTelInputCountry,
    MuiTelInputInfo,
    MuiTelInputProps
} from 'mui-tel-input';
import * as React from 'react';

type DefaultPhoneFieldProps = {
    field: FieldState<string>;
    dataRole?: string;
} & MuiTelInputProps &
    Omit<TextFieldProps, 'onChange'>;

const DefaultPhoneField = (props: DefaultPhoneFieldProps) => {
    const { children, onChange, field, dataRole = 'phone', ...rest } = props;
    const { value, error } = field;
    const { country } = injectTSDI(I18nStore);

    const onChangeHandler = (value: string, info: MuiTelInputInfo) => {
        if (typeof onChange === 'function') {
            onChange(value, info);
            return;
        }
        if (field) {
            field.onChange(value);
        }
    };

    const getDefaultCountryCode = React.useCallback((): MuiTelInputCountry => {
        if (country === 'UK') {
            return 'GB';
        }
        return country?.toUpperCase() as MuiTelInputCountry;
    }, [country]);

    return (
        <MuiTelInput
            defaultCountry={getDefaultCountryCode()}
            preferredCountries={[
                'DE',
                'AT',
                'FR',
                'ES',
                'IT',
                'GB',
                'NL',
                'CH'
            ]}
            error={!!error}
            onBlur={() => field.validate()}
            onChange={onChangeHandler}
            helperText={error}
            variant="outlined"
            value={value}
            fullWidth
            slotProps={{
                htmlInput: {
                    'data-role': dataRole
                }
            }}
            {...rest}
        >
            {children}
        </MuiTelInput>
    );
};

export default observer(DefaultPhoneField);
